export default "/images/963d477c0fe0c28220d3a9cfbab4ab81.avif";